import React from 'react';

import arrowImage from '../arrow-link/arrow.svg';

import iconFacebook from './facebook.svg';
import iconTwitter from './twitter.svg';
import iconEnvelope from './envelope.svg';
import iconPrinter from './printer.svg';

export class ContentShare extends React.Component {
  constructor (props) {
    super(props);
    this.state = {};
  }

  openWindow (url) {
    window.open(
      url,
      'shareWindow',
      'height=450, width=550, top=' + (window.innerHeight / 2 - 275) + ', left=' + (window.innerWidth / 2 - 225) + ', toolbar=0, location=0, menubar=0, directories=0, scrollbars=0'
    );
  }

  facebook = () => {
    var url = 'https://www.facebook.com/sharer/sharer.php?u=' + encodeURIComponent(window.location.href);
    this.openWindow(url);
  }

  twitter = () => {
    var url = 'https://twitter.com/intent/tweet?url' + encodeURIComponent(window.location.href);
    this.openWindow(url);
  }

  mail = () => {
    var url = `mailto:someone@example.com?subject=${document.title}&body=${window.location.href}`;
    window.location.href = url;
  }

  print = () => {
    window.print();
  }
  
  render () {
    return (
      <div>
        { this.props.event && (
          <React.Fragment>
            { this.props.event.readMore && (
              <a className="content-share content-share--clickable" target="_blank" href={this.props.event.readMore}>
                <div className="content-share__left">
                  Read more <img src={arrowImage} className="content-share__arrow" />
                </div>
              </a>
            ) }
          </React.Fragment>
        )}

        <div className="content-share">
          <div className="content-share__left">
            Share this <img src={arrowImage} className="content-share__arrow" />
          </div>
          <div className="content-share__right">
            <img src={ iconFacebook } onClick={this.facebook} />
            <img src={ iconTwitter } onClick={this.twitter} />
            <img src={ iconEnvelope } onClick={this.mail} />
          </div>
        </div>
        <div className="content-share">
          <div className="content-share__left">
            Print this <img src={arrowImage} className="content-share__arrow" />
          </div>
          <div className="content-share__right">
            <img src={ iconPrinter } onClick={this.print} />
          </div>
        </div>
      </div>
    );
  }
}
